import { actionTypes } from '../../constants';
import { accountService } from '@virginmoney/api-connector-lib';

export const getAccountDetails = (
  baseUrl,
  bankId,
  token,
  accountId,
  userTrackingId
) => dispatch => {
  dispatch({
    type: actionTypes.FETCH_ACCOUNT_DETAILS,
    apiMethod: accountService.getAccountDetails(baseUrl, bankId, token, accountId, userTrackingId),
    success: getAccountDetailsSuccess,
    failure: getAccountDetailsFailure,
    isLoading: true,
    sucessParam: { baseUrl, bankId, token, accountId }
  });
};
const getAccountDetailsSuccess = data => dispatch => {
  dispatch({
    type: actionTypes.FETCH_ACCOUNT_DETAILS_SUCCESS,
    data: data,
    isLoading: false
  });
};
const getAccountDetailsFailure = () => ({
  type: actionTypes.FETCH_FAILED,
  isLoading: false
});
